import React from 'react'

import { Typography, Grid, Link } from '@mui/material'
import MailIcon from '@mui/icons-material/Mail'
import styled from '@emotion/styled'
import { makeStyles } from 'tss-react/mui'
import { Marker, Popup } from 'react-leaflet'
import { Icon } from 'leaflet'
import colors from '../../../assets/styles/styles.module.scss'
import { LazyLoadImage } from 'react-lazy-load-image-component'

interface ICampusMarker {
  latitude: number
  longitude: number
  firstAddress: string
  city: string
  country: string
  email?: string
  logoUrl: string
}

const StyledPop = styled(Popup)`
  .leaflet-popup-content-wrapper {
    border-radius: 0;
  }
`

const useStyles = makeStyles()(() => {
  return {
    content: {
      display: 'block',
      fontSize: '11px',
      margin: '0 !important',
      color: 'black',
    },
    contact: {
      display: 'flex',
      fontSize: '11px',
      color: colors.purple,
      fontWeight: 'bold',
      alignItems: 'center',
      margin: '10px 0 0 0 !important',
    },
    email: { color: `${colors.purple} !important` },
  }
})

const marker = new Icon({
  iconUrl: 'https://i.ibb.co/8cxMhXJ/mapIcon.png',
  iconSize: [30, 30],
})

export default function CampusMarker({
  latitude,
  longitude,
  firstAddress,
  city,
  country,
  email,
  logoUrl,
}: ICampusMarker) {
  const { classes } = useStyles()

  return (
    <Marker position={[latitude, longitude]} icon={marker}>
      <StyledPop>
        <Grid m={1}>
          {logoUrl && (
            <LazyLoadImage
              effect='opacity'
              src={logoUrl}
              alt='Logo Éstiam'
              width={128}
              height={38}
            />
          )}
          <Grid mt={3}>
            <Typography className={classes.content}>{firstAddress}</Typography>
            <Typography className={classes.content} pt={1}>
              {city}
            </Typography>
            <Typography className={classes.content}> {country}</Typography>
            <Typography className={classes.contact}>
              <MailIcon
                sx={{
                  color: colors.purple,
                  width: '12px',
                  height: '12px',
                  marginRight: '5px',
                }}
              />
              <Link href={'mailto:' + email} className={classes.email} underline='none'>
                {email}
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </StyledPop>
    </Marker>
  )
}
